import React from "react";
import {Button, Tooltip} from "antd";
import {EyeOutlined} from "@ant-design/icons";
import {useExecuteModal} from "../../../../hooks/useExecuteModal";
import {DepartmentDataService} from "../../../../models/DepartmentData/DepartmentDataService";
import ViewDepartmentDataServicesModal from "../../../modals/departmentData/DeparmentDataServicesModal/ViewDepartmentDataServicesModal";
import {DEPARTMENT_DATA_SERVICES} from "../../../../constants/translates";

type ViewServicesButtonProps = {
  services: DepartmentDataService[];
};

const ViewServicesButton = ({services}: ViewServicesButtonProps) => {
  const modalHandler = useExecuteModal();

  return (
    <>
      <Tooltip title={DEPARTMENT_DATA_SERVICES.view}>
        <Button
          type="link"
          aria-label={DEPARTMENT_DATA_SERVICES.view}
          onClick={modalHandler.executeModal}
        >
          <EyeOutlined />
        </Button>
      </Tooltip>
      <ViewDepartmentDataServicesModal
        handler={modalHandler}
        services={services}
      />
    </>
  );
};

export default ViewServicesButton;
